import { css } from 'aphrodite';
import * as React from 'react';
import { EyeIcon } from '../../../components/svgs/icons/EyeIcon';
import { EyeSlashIcon } from '../../../components/svgs/icons/EyeSlashIcon';
import { styleSheet as loginStyleSheet } from '../styles';
import { styleSheet } from './styles';

export interface IPasswordInputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
	showToggleButton?: boolean;
}

export const PasswordInputField: React.FC<IPasswordInputFieldProps> = props => {
	const { children, className, showToggleButton = true, ...restProps } = props;
	const [isVisible, setIsVisible] = React.useState(false);

	const toggleVisibility = React.useCallback(() => {
		setIsVisible(prev => !prev);
	}, []);

	return (
		<div className={`${css(loginStyleSheet.formField)} ${className || ''}`}>
			<input {...restProps} className={css(loginStyleSheet.input)} type={isVisible ? 'text' : 'password'} />
			{showToggleButton && (
				<button
					type='button'
					className={css(styleSheet.toggleButton)}
					onClick={toggleVisibility}
					tabIndex={-1}
					aria-label={isVisible ? 'Hide password' : 'Show password'}
				>
					{isVisible ? <EyeIcon /> : <EyeSlashIcon />}
				</button>
			)}
			{children}
		</div>
	);
};
